<div class="tw-flex tw-h-full tw-w-full">
    <app-extended-table
        #ExtendedTableComponent
        [hideResetFilterIcon]="isClientSide"
        [activeTabs]="activeTabs"
        [customAgGridFilters]="gridStateReady()"
        [isSidebarVisible]="showExtendedTable()"
        (applyGridFilters)="applyGridFilters($event)"
        (sidebarResized)="onSidebarResized()"
    >
        <ng-container Table [ngTemplateOutlet]="table"></ng-container>
    </app-extended-table>
</div>

<ng-template #table>
    @if(!isClientSide) {
        <app-grid-server-side
            #itemsGridComponent
            feature="items"
            [headerCheckboxSelection]="true"
            (areRowsSelected)="handleSelectionChange($event)"
            (rowClicked)="rowClicked($event)"
            [cacheBlockSize]="query.per_page"
            [datasource]="datasource"
            [hidden]="!gridPath"
            [fixedButtons]="fixedButtons"
            [tableData]="tableData[0]"
            (deleteChange)="deleteItems($event)"
            (gridReadyEmitter)="onGridReady()"
            (filterChangedEmitter)="onFilterChangedEmitter($event)"
            [exportFormatterOptions]="exportFormatterOptions"
            (clickableAction)="actions($event)"
        ></app-grid-server-side>
    }
    @else {
        <app-grid-client-side
            #itemsGridComponent
            feature="items"
            [headerCheckboxSelection]="true"
            (areRowsSelected)="handleSelectionChange($event)"
            (rowClicked)="rowClicked($event)"
            [hidden]="!gridPath"
            [fixedButtons]="fixedButtons"
            [tableData]="tableData[0]"
            (deleteChange)="deleteItems($event)"
            (gridReadyEmitter)="onGridReady()"
            (filterChangedEmitter)="onFilterChangedEmitter($event)"
            [exportFormatterOptions]="exportFormatterOptions"
            (clickableAction)="actions($event)"
        ></app-grid-client-side>
    }
</ng-template>  

<app-barcode [hideButton]="true" (onSubmitBarcode)="onBarcodeScanned($event)"></app-barcode>